import React from 'react';
import PropTypes from 'prop-types';
import { DropdownWithButton } from 'chameleon/ui-stack/ui/dropdowns';
import { QUESTION_TYPES } from 'chameleon-src/constants/assignment';
import { buttonClassName, iconProps } from './constants';

const AssignByType = ({ onClick }) => (
  <DropdownWithButton
    className={buttonClassName}
    accessibility={{ 'aria-label': 'Assign' }}
    button="Assign"
    {...iconProps}
    options={[
      {
        title: 'All Topic Questions',
        action: () => onClick(),
      },
      {
        title: 'Only MCQs',
        action: () => onClick(QUESTION_TYPES.mcq),
      },
      {
        title: 'Only FRQs',
        action: () => onClick(QUESTION_TYPES.frq),
      },
    ]}
  />
);

AssignByType.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default AssignByType;
